module.exports.prebidConfig = {
  debug: false,
  priceGranularity: {
    buckets: [
      {
        precision: 2,
        min: 0,
        max: 3,
        increment: 0.01
      },
      {
        precision: 2,
        min: 3,
        max: 8,
        increment: 0.05
      },
      {
        precision: 2,
        min: 8,
        max: 20,
        increment: 0.5
      }
    ]
  },
  consentManagement: {
    cmpApi: 'iab',
    timeout: 8000,
    defaultGdprScope: true
  },
  userSync: {
    userIds: [
      {
        name: 'pubCommonId',
        storage: {
          type: 'html5',
          name: '_pubcid',
          expires: 90
        }
      },
      {
        name: 'uid2'
      },
      {
        name: 'lotamePanoramaId',
      }
    ],
    /* http://prebid.org/dev-docs/publisher-api-reference.html */
    filterSettings: {
      iframe: {
        bidders: [ 'ozone' ],
        filter: 'include'
      }
    },
    auctionDelay: 50
  },
  currency: {
    adServerCurrency: 'GBP',
    granularityMultiplier: 1,
    defaultRates: {
      USD: {
        GBP: 0.8
      }
    }
  },
  improvedigital: {
    usePrebidSizes: true
  },
  realTimeData: {
    auctionDelay: 500,
    dataProviders: [
      {
        name: 'brandmetrics',
        waitForIt: true,
        params: {
          scriptId: '10c417289f6b4ce89f1ef4f55fd03c8d',
          bidders: ['ozone']
        }
      }
    ]
  }
};
